// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var InstrumentDeliveryType;
(function (InstrumentDeliveryType) {
    InstrumentDeliveryType[InstrumentDeliveryType["Delivery_Physical"] = 0] = "Delivery_Physical";
    InstrumentDeliveryType[InstrumentDeliveryType["Delivery_Cash"] = 1] = "Delivery_Cash";
})(InstrumentDeliveryType || (InstrumentDeliveryType = {}));
